import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-66724f40"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  "data-testid": "rerouting-image",
  class: "rerouting__rerouting-image",
  src: "https://dam.malt.com/profile/signup/rerouting?vh=bb3327",
  alt: "rerouting-to-open-marketplace"
}, null, -1))
const _hoisted_2 = {
  "data-testid": "rerouting-title",
  class: "rerouting__title"
}
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = ["innerHTML"]

import {string} from 'vue-types';
    import {ref} from 'vue';
    import {useTranslation} from '@malt/vue3-use';
    import {useRouter} from 'vue-router';
    import ReroutingTransition from '@/profile-creation-wizard/components/for-creation/ui/ReroutingTransition.vue';
    import {linkToMarketplace} from '@/profile-creation-wizard/router/funnelSwitch';

    import {useStore} from 'vuex';
    import {useRoute} from 'vue-router';
    
export default /*#__PURE__*/_defineComponent({
  __name: 'ReroutingToOpenMarketplace',
  props: {
        title: string().isRequired,
        line1: string(),
        line2: string(),
    },
  emits: ['reroute-to-marketplace'],
  setup(__props, { emit }) {

const props = __props;

    const {msg} = useTranslation();
    const router = useRouter();
    
    const showTransition = ref(false);
    const store = useStore();
    const route = useRoute();

    

    function triggerRerouting() {
        const familiesCategoriesData = store.state.creationStore.form.familiesCategoriesEdition;
        const isCategorizationManual = !!familiesCategoriesData.manual.selectedFamily;

        const dataBeforeReroute = {
            currentStep: route.name,
            headline: store.state.creationStore.form.headline,
            isCategorizationInputManual: isCategorizationManual,
            categorizationData: {...familiesCategoriesData.manual},
            experienceLevel: store.state.creationStore.form.experienceLevel,
        };
        sessionStorage.setItem('funnelData', JSON.stringify(dataBeforeReroute));
        emit('reroute-to-marketplace');
        showTransition.value = true;
        setTimeout(redirect, 3000);
    }

    function redirect() {
        window.location.href = linkToMarketplace(router.currentRoute.value.path);
    }

return (_ctx: any,_cache: any) => {
  const _component_VJoyWrapper = _resolveComponent("VJoyWrapper")!
  const _component_VJoyButton = _resolveComponent("VJoyButton")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_VJoyWrapper, {
      class: "rerouting",
      "row-gap": "0"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_VJoyWrapper, {
          wrap: "nowrap",
          "no-margin": "",
          align: "center"
        }, {
          default: _withCtx(() => [
            _hoisted_1,
            _createVNode(_component_VJoyWrapper, {
              wrap: "nowrap",
              direction: "column",
              align: "flex-start",
              "row-gap": "0",
              "no-margin": ""
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_2, _toDisplayString(props.title), 1),
                _createElementVNode("div", {
                  "data-testid": "rerouting-details-line1",
                  class: "rerouting__details",
                  innerHTML: props.line1
                }, null, 8, _hoisted_3),
                _createElementVNode("div", {
                  "data-testid": "rerouting-details-line2",
                  class: "rerouting__details",
                  innerHTML: props.line2
                }, null, 8, _hoisted_4)
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_VJoyButton, {
          "data-testid": "rerouting-cta",
          class: "rerouting__cta",
          variant: "main",
          onClick: triggerRerouting
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(msg)('profile.creation.wizard.strategy.categorization.rerouting.cta.label')), 1)
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    (showTransition.value)
      ? (_openBlock(), _createBlock(ReroutingTransition, { key: 0 }))
      : _createCommentVNode("", true)
  ], 64))
}
}

})